import {Action} from '@ngrx/store';
import {Site} from '../models/site';
import {type} from '../utilities/type';

export const currentSiteActionTypes = {
  LOAD: type('[Current Site] Load'),
  LOAD_SUCCESS: type('[Current Site] Load Success'),
  LOAD_FAIL: type('[Current Site] Load Fail')
};

export class LoadCurrentSiteAction implements Action {
  readonly type = currentSiteActionTypes.LOAD;
  constructor(public payload?: string) {}
}

export class LoadCurrentSiteSuccessAction implements Action {
  readonly type = currentSiteActionTypes.LOAD_SUCCESS;
  constructor(public payload?: Site) {}
}

export class LoadCurrentSiteFailAction implements Action {
  readonly type = currentSiteActionTypes.LOAD_FAIL;
  constructor(public payload?: string) {}
}
